import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../shared/services/dialog.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { EnvService } from '../../shared/services/env.service';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { KitchenStockItemService } from '../../shared/services/kitchen-stock-item.service';
import * as XLSX from 'xlsx'; 



@Component({
  selector: 'ngx-kitchen-stock-bal',
  templateUrl: './kitchen-stock-bal.component.html',
  styleUrls: ['./kitchen-stock-bal.component.scss']
})
export class KitchenStockBalComponent implements OnInit {

  searchKey : string;
  isDark: boolean = false;
  btnHideId=[]
  itemCount:number;
  item : any[];
  filteredFinalList: any[]=[];
  statusCode: number;
  apiUrl: string;
  private _album:any[]  = [];

  constructor(private kitchenStockItemService : KitchenStockItemService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private decimalPipe: DecimalPipe,
              private env: EnvService,
              ) { 
                this.apiUrl = this.env.apiUrl;
              }

  ngOnInit() {
    this.getAllItems();

  }


  
getAllItems(){
    this.kitchenStockItemService.getAll()
      .subscribe({
        next:(res)=>{
          this.item = res.map(obj => ({...obj, filled : false}));  
          this.filteredFinalList = this.item;       
        },
        error: (err)=>{
          if (err instanceof HttpErrorResponse) {
            if (err.status == 401) {
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      });
     
  }

   
  
     applyFilter(){
      this.filteredFinalList = this.item.filter((el)=>{
         return el.Name.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1
       });


     }
     onSearchClear(){
       this.searchKey = "";
       this.applyFilter();
     }

  

     savePDF(action:string){

      const documentDefinition:any = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Kitchen Stock Balance', style: 'reportHeader' }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['*', 'auto', 'auto'],  
                body: [  
                  ['Item', 'Unit',  'Qty Bal'],
                  ...this.filteredFinalList.map(p => ([p.Name, p.Unit, { text : this.transformNumberFormat(p.QtyBal),alignment: 'right'  }])),  
                  //[ { text: 'Total balance due', bold: true, colSpan: 9 }, {},{},{},{},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotalBalance()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
    
        let element = document.getElementById('offerListReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 

        XLSX.writeFile(wb, 'Customer Outstanding Report.xlsx');
       
     }

     transformNumberFormat(number:any) {
         return this.decimalPipe.transform(Number(number),'1.2-2');
      }




    }